export default "__VITE_ASSET__vr4LGtvf__"